import { ITile } from "@faire/web-api--source/indigofair/data/ITile";

import { SDUIProductTileRenderer } from "./ProductTile/SDUIProductTileRenderer";
import { SDUIProductTileWithBrand } from "./ProductTile/SDUIProductTileWithBrandRenderer";
import { SDUIAvatarInfoCardTileRenderer } from "./SDUIAvatarInfoCardTile";
import { SDUIAvatarTileRenderer } from "./SDUIAvatarTileRenderer";
import { SDUIBrandInsightsTileRenderer } from "./SDUIBrandInsightsTileRenderer";
import { SDUIBrandTileRenderer } from "./SDUIBrandTileRenderer";
import { SDUIBrandTileWithActionRenderer } from "./SDUIBrandTileWithActionRenderer";
import { SDUIButtonTileRenderer } from "./SDUIButtonTileRenderer";
import { SDUIImageFanTileRenderer } from "./SDUIImageFanTileRenderer";
import { SDUIImageGalleryTileRenderer } from "./SDUIImageGalleryTileRenderer";
import { SDUIImageTileRenderer } from "./SDUIImageTileRenderer";
import { SDUIPillTileRenderer } from "./SDUIPillTileRenderer";
import { SDUITextTileRenderer } from "./SDUITextTileRenderer";
import { SDUITileInstanceRendererProps } from "./types";

enum TileType {
  BRAND_TILE,
  BRAND_TILE_WITH_PRODUCTS,
  BRAND_TILE_WITH_ACTION,
  PRODUCTS_WITH_BRAND_INFO_TILE,
  PRODUCT_TILE,
  IMAGE_TILE,
  PILL_TILE,
  IMAGE_GALLERY_TILE,
  TEXT_TILE,
  AVATAR_TILE,
  BRAND_INSIGHTS_TILE,
  BUTTON_TILE,
  IMAGE_FAN_TILE,
  AVATAR_INFO_CARD_TILE,
}

const tileRendererMap: Partial<
  Record<TileType, React.FC<SDUITileInstanceRendererProps> | undefined>
> = {
  [TileType.BRAND_TILE]: SDUIBrandTileRenderer,
  [TileType.BRAND_TILE_WITH_ACTION]: SDUIBrandTileWithActionRenderer,
  [TileType.PRODUCTS_WITH_BRAND_INFO_TILE]: SDUIProductTileWithBrand,
  [TileType.PRODUCT_TILE]: SDUIProductTileRenderer,
  [TileType.IMAGE_TILE]: SDUIImageTileRenderer,
  [TileType.PILL_TILE]: SDUIPillTileRenderer,
  [TileType.IMAGE_GALLERY_TILE]: SDUIImageGalleryTileRenderer,
  [TileType.TEXT_TILE]: SDUITextTileRenderer,
  [TileType.AVATAR_TILE]: SDUIAvatarTileRenderer,
  [TileType.BRAND_INSIGHTS_TILE]: SDUIBrandInsightsTileRenderer,
  [TileType.BUTTON_TILE]: SDUIButtonTileRenderer,
  [TileType.IMAGE_FAN_TILE]: SDUIImageFanTileRenderer,
  [TileType.AVATAR_INFO_CARD_TILE]: SDUIAvatarInfoCardTileRenderer,
};

export const getTileComponent = (
  tileElement: ITile
): React.FC<SDUITileInstanceRendererProps> | undefined => {
  if (tileElement.brand_tile) {
    return tileRendererMap[TileType.BRAND_TILE];
  } else if (tileElement.brand_tile_with_action) {
    return tileRendererMap[TileType.BRAND_TILE_WITH_ACTION];
  } else if (tileElement.product_tile) {
    return tileRendererMap[TileType.PRODUCT_TILE];
  } else if (tileElement.product_with_brand_info_tile) {
    return tileRendererMap[TileType.PRODUCTS_WITH_BRAND_INFO_TILE];
  } else if (tileElement.image_tile) {
    return tileRendererMap[TileType.IMAGE_TILE];
  } else if (tileElement.pill_tile) {
    return tileRendererMap[TileType.PILL_TILE];
  } else if (tileElement.image_gallery_tile) {
    return tileRendererMap[TileType.IMAGE_GALLERY_TILE];
  } else if (tileElement.text_tile) {
    return tileRendererMap[TileType.TEXT_TILE];
  } else if (tileElement.avatar_tile) {
    return tileRendererMap[TileType.AVATAR_TILE];
  } else if (tileElement.brand_insights_tile) {
    return tileRendererMap[TileType.BRAND_INSIGHTS_TILE];
  } else if (tileElement.button_tile) {
    return tileRendererMap[TileType.BUTTON_TILE];
  } else if (tileElement.image_fan_tile) {
    return tileRendererMap[TileType.IMAGE_FAN_TILE];
  } else if (tileElement.avatar_info_card_tile) {
    return tileRendererMap[TileType.AVATAR_INFO_CARD_TILE];
  }
  return undefined;
};
